module.exports = __webpack_public_path__ + "img/richard-pro.5cf78844.jpg";